import { isInternal } from './isInternal';

export const normalizeHref = (href: string) => {
	let hrefCopy = href;
	if (
		href &&
		!isInternal(href) &&
		!href.includes('http:') &&
		!href.includes('https:') &&
		!href.startsWith('#') &&
		!href.startsWith('mailto:')
	) {
		hrefCopy = 'https://' + href;
	}
	return hrefCopy;
};
